import React from "react";
import { useTheme } from "@mui/material/styles";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import Chip from "@mui/material/Chip";
import InfoCircleOutlined from "@ant-design/icons/InfoCircleOutlined";

import { SolidButton } from "components/buttons/SolidButton";
import { SolidWarnButton } from "components/buttons/SolidWarnButton";

import icon_verified from "assets/images/icons/icn_table_cell_Verified_green.png";
import icon_inactivated from "assets/images/icons/icn_table_cell_Status_Inactivated.png";
import { LICENSE_SERVICE_STATUS_ACTIVE } from "const/license";

const ServiceCard = ({
  title,
  status,
  price,
  scope,
  devices,
  isMspManaged,
  onAction,
}) => {
  const theme = useTheme();
  const isActive = status === LICENSE_SERVICE_STATUS_ACTIVE;

  return (
    <Box
      sx={{
        p: 2,
        bgcolor: "common.white",
        borderRadius: "10px",
        border: "1px solid rgba(0,0,0,0.08)",
        height: "100%",
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",
      }}
    >
      <Stack spacing={1.5}>
        <Stack direction='row' justifyContent='space-between' alignItems='flex-start'>
          <Typography variant='subtitle1' sx={{ fontWeight: "bold", color: "#172664" }}>
            {title}
          </Typography>
          <Chip
            icon={
              <img
                src={isActive ? icon_verified : icon_inactivated}
                alt={isActive ? "activated" : "inactivated"}
                style={{ width: "20px", height: "20px" }}
              />
            }
            label={isActive ? "Activated" : "Inactivated"}
            size='small'
            sx={{
              bgcolor: isActive ? "#F6FFED" : "rgba(0,0,0,0.04)",
              color: isActive ? "#008514" : "rgba(0,0,0,0.45)",
              fontWeight: "bold",
              fontSize: "10px",
              borderRadius: "6px",
              border: isActive ? "1px solid #B7EB8F" : "1px solid #D9D9D9",
              "& .MuiChip-icon": { marginLeft: "8px" },
            }}
          />
        </Stack>

        <Stack spacing={0.5}>
          <Typography variant='body2' sx={{ color: "#373737", fontWeight: "bold" }}>
            {devices !== undefined && (
              <>
                <Box component='span' sx={{ color: "#008514" }}>
                  {devices}
                </Box>
                {" Devices • "}
              </>
            )}
            {scope && (
              <Box component='span' sx={{ color: "rgba(0,0,0,0.45)", fontWeight: "normal" }}>
                {scope} |{" "}
              </Box>
            )}
            {(() => {
              const match = (price || "").match(/^([\d.]+)\s*(.*)$/);
              if (!match) return price;
              return (
                <>
                  <Box component='span' sx={{ color: "#008514" }}>
                    {match[1]}
                  </Box>{" "}
                  {match[2]}
                </>
              );
            })()}
          </Typography>
          {isMspManaged && (
            <Stack direction='row' spacing={0.5} alignItems='center'>
              <InfoCircleOutlined style={{ fontSize: "14px", color: theme.palette.text.secondary }} />
              <Typography variant='caption' color='textSecondary'>
                Managed by MSP administrator
              </Typography>
            </Stack>
          )}
        </Stack>
      </Stack>

      <Box sx={{ mt: 2, display: "flex", justifyContent: "flex-start" }}>
        {isActive ? (
          <SolidWarnButton
            disabled={isMspManaged}
            onClick={() => onAction && onAction("deactivate")}
            width='120px'
            height='36px'
            sx={{ bgcolor: "#D1003B", borderRadius: "20px", "&:hover": { bgcolor: "#A8002F" } }}
          >
            Deactivate
          </SolidWarnButton>
        ) : (
          <SolidButton
            disabled={isMspManaged}
            onClick={() => onAction && onAction("activate")}
            width='120px'
            height='36px'
            sx={{ bgcolor: "#172664", borderRadius: "20px", "&:hover": { bgcolor: "#23367d" } }}
          >
            Activate
          </SolidButton>
        )}
      </Box>
    </Box>
  );
};

export default ServiceCard;
